import { useContext, useEffect } from "react";

import { SingleBuildingContext } from "../../context/AddSingleBuildingContext";
import { useHandleAutomaticOutlineDetection } from "./hooks/useHandleAutomaticOutlineDetection";

export const OutlineDataGetter = () => {
  const { formData, pauseInteraction, setBuildingOutline, setOutlineState, stepNo } = useContext(SingleBuildingContext);

  const { isErrorOutline, isLoadingOutline } = useHandleAutomaticOutlineDetection({
    formData,
    pauseInteraction,
    setBuildingOutline,
    stepNo,
  });

  useEffect(() => {
    setOutlineState({
      isErrorOutline,
      isLoadingOutline,
    });
  }, [isErrorOutline, isLoadingOutline, setOutlineState]);
  return <></>;
};
